import { commitinfo } from './00_commitinfo_data.js';
import { html, render } from '@designestate/dees-element';
import { PcHeader } from './elements/header';
import { PcFooter } from './elements/footer';

export {
  PcHeader,
  PcFooter
};

const mainTemplate = html`
  <style>
    body {
      background: #000;
      font-family: 'Roboto', sans-serif;
      color: #fff;
      margin: 0px;
      --background-accent: #303F9F;
    }
  </style>
  <lele-statusbar .commitinfo=${commitinfo}></lele-statusbar>
  <pc-header></pc-header>
  <pc-footer></pc-footer>
`;

render(mainTemplate, document.body);
